import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import useGoogleMaps from './useGoogleMaps';
export default function usePlacesAutocomplete() {
  var _useGoogleMaps = useGoogleMaps(),
    loader = _useGoogleMaps.loader;
  var autocomplete = reactive({});
  var buildAutocomplete = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(element, handler) {
      var configuration,
        google,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            configuration = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            _context.next = 3;
            return loader.load();
          case 3:
            google = _context.sent;
            // @ts-ignore
            autocomplete.value = new google.maps.places.Autocomplete(element, _objectSpread({
              fields: ['address_components'],
              types: ['address']
            }, configuration));
            // @ts-ignore
            autocomplete.value.addListener('place_changed', handler);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function buildAutocomplete(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    autocomplete: autocomplete,
    buildAutocomplete: buildAutocomplete
  };
}